import { Spacing } from "~/jsx/theme";
import { typedEntries } from "../../../../../core/src/core";
import { XResourceType } from "./svg";
import { XResourceWithAmount } from "./XResourceWithAmount";

export const XResources = ({
  resources,
  width,
}: {
  resources: Partial<Record<XResourceType, number>>;
  width: number;
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        justifyContent: "flex-end",
      }}
    >
      {typedEntries(resources).map(([resourceType, amount]) => (
        <XResourceWithAmount
          key={resourceType}
          type={resourceType}
          amount={amount ?? 0}
          width={width}
          variant="separated"
          style={{ width: 40, justifyContent: "flex-end", gap: Spacing.px4 }}
        />
      ))}
    </div>
  );
};
